export const validItemIdFormat = /^[0-9]*$/;

export const validBusinessIdFormat = /^[0-9]{8}$/;

export const pureNumber = /^[0-9]+.?[0-9]*$/;
